export const accountPaths = {
  CREATE_ACCOUNT: "register",
};
